import React from 'react';
import Navbar from '../../components/Header';
import Footer from '../../components/Footer';

function Privacy() {
  return (
    <div>
      <Navbar diffHeader={true} />
      <div className="justify-left text-left relative mt-[8%] z-10 overflow-hidden bg-gray-100 py-20 dark:bg-dark  px-[3%] mx-auto md:mt-[2%] *:font-sans">
        <h1 className="font-bold my-10 text-[32px] text-center">
          Privacy Policy
        </h1>
        <h1 className="font-semibold my-10">Our Values</h1>
        <p>
          Should we ask you to provide certain information by which you can be
          identified when using this website, then you can be assured that it
          will only be used in accordance with this privacy statement. UCS Prime
          real estate may change this policy from time to time by updating this
          page. You should check this page from time to time to ensure that you
          are happy with any changes. This policy is effective from May 31st,
          2024.
        </p>

        <h1 className="font-semibold my-10">What we collect</h1>
        <p>
          We may collect the following information:
          <br />
          ● Contact information including email address <br />
          ● Demographic information such as postcode, preferences and interests
          <br />
          ● Other information relevant to customer surveys and/or offers <br />
        </p>

        <h1 className="font-semibold my-10">
          What we do with the information we gather
        </h1>
        <p>
          We require this information to understand your needs and provide you
          with a better service, and in particular for the following reasons:
          <br />
          ● We may use the information to improve our products and services.
          <br />
          ● We may periodically send promotional emails about new products,
          special offers or other information which we think you may find
          interesting using the email address which you have provided.
          <br />
          From time to time, we may also use your information to contact you for
          market research purposes. We may contact you by email, phone, fax or
          mail. We may use the information to customize the website according to
          your interests.
        </p>

        <h1 className="font-semibold my-10">Security</h1>
        <p>
          We are committed to ensuring that your information is secure. In order
          to prevent unauthorized access or disclosure, we have put in place
          suitable physical, electronic and managerial procedures to safeguard
          and secure the information we collect online
        </p>

        <h1 className="font-semibold my-10">How we use cookies</h1>
        <p>
          A cookie is a small file which asks permission to be placed on your
          computer’s hard drive. Once you agree, the file is added and the
          cookie helps analyze web traffic or lets you know when you visit a
          particular site. Cookies allow web applications to respond to you as
          an individual. The web application can tailor its operations to your
          needs, likes and dislikes by gathering and remembering information
          about your preferences. We use traffic log cookies to identify which
          pages are being used. This helps us analyze data about webpage traffic
          and improve our website in order to tailor it to customer needs. We
          only use this information for statistical analysis purposes and then
          the data is removed from the system. Overall, cookies help us provide
          you with a better website, by enabling us to monitor which pages you
          find useful and which you do not. A cookie in no way gives us access
          to your computer or any information about you, other than the data you
          choose to share with us. You can choose to accept or decline cookies.
          Most web browsers automatically accept cookies, but you can usually
          modify your browser setting to decline cookies if you prefer. This may
          prevent you from taking full advantage of the website.
        </p>

        <h1 className="font-semibold my-10">Links to other websites</h1>
        <p>
          Our website may contain links to other websites of interest. However,
          once you have used these links to leave our site, you should note that
          we do not have any control over that other website. Therefore, we
          cannot be responsible for the protection and privacy of any
          information which you provide whilst visiting such sites and such
          sites are not governed by this privacy statement. You should exercise
          caution and look at the privacy statement applicable to the website in
          question. Some of these links may be affiliate links that allow me to
          operate this website{' '}
        </p>

        <h1 className="font-semibold my-10">
          Controlling your personal information
        </h1>
        <p>
          You may choose to restrict the collection or use of your personal
          information in the following ways: <br />
          ● whenever you are asked to fill in a form on the website, look for
          the box that you can click to indicate that you do not want the
          information to be used by anybody for direct marketing purposes
          <br />
          ● If you have previously agreed to us using your personal information
          for direct marketing purposes, you may change your mind at any time by
          contacting us.
          <br />
          ● We will not sell, distribute or lease your personal information to
          third parties unless we have your permission or are required by law to
          do so. We may use your personal information to send you promotional
          information about third parties which we think you may find
          interesting if you tell us that you wish this to happen.
          <br />
          If you believe that any information we are holding on you is incorrect
          or incomplete, please contact us
        </p>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
